import { useEffect } from "react";
import { useRouter } from "next/router";
import { COOKIE } from "~/const/cookie";
import { useQueryString } from "~/hooks/use-query-string";

/**
 * ### useDisableAdult
 * 説明
 * - pathに?adが含まれていた時、cookieにadult_link_disableをセットする
 * - ?adが含まれた状態で再訪問時、値は上書きされる
 * - ブラウザ終了時にcookieにセットした値は消える
 * */
export const useDisabledAdult = () => {
  const { isReady } = useRouter();
  const { ad } = useQueryString();

  useEffect(() => {
    if (!isReady) return;
    if (ad === undefined) return;

    document.cookie = `${COOKIE.ADULT_LINK_DISABLE.KEY}=${COOKIE.ADULT_LINK_DISABLE.VALUE}`;
  }, [ad, isReady]);
};
